export default __webpack_public_path__ + "static/media/greyEnvelope.88c85772.svg";